import { forwardRef, ReactNode } from 'react';

import { SelectableCard } from '@/policy/component/SelectableCard/SelectableCard';
import { useValidationHandlers } from '@/policy/hooks/useValidationHandlers';
import { ValidationResult } from '@/policy/types/ValidationResult';

import { ExtractionStatusIndicators } from './ExtractionStatusIndicators';

interface ValidableSectionProps {
  title?: string;
  subheader?: ReactNode;
  sectionIdentifier: string;
  validation: ValidationResult;
  onValidationChange: (validation: ValidationResult) => void;
  isSelected: boolean;
  onTableClick: (sectionUuid: string) => void;
  className?: string;
  children: ReactNode;
}

export const ValidableSection = forwardRef<
  HTMLDivElement,
  ValidableSectionProps
>(
  (
    {
      title,
      subheader,
      sectionIdentifier,
      validation,
      onValidationChange,
      isSelected,
      onTableClick,
      className,
      children,
    },
    ref,
  ) => {
    const {
      handleCoherentClick,
      handleErrorClick,
      handleDescriptionChange,
      handleCancel,
      handleSave,
    } = useValidationHandlers({ validation, onValidationChange });

    return (
      <SelectableCard
        ref={ref}
        title={title}
        subheader={subheader}
        isSelected={isSelected}
        wrapperClassName={className}
        onClick={() => onTableClick(sectionIdentifier)}
      >
        {children}
        <div className="p-2">
          <ExtractionStatusIndicators
            validation={validation}
            onCoherentClick={handleCoherentClick}
            onErrorClick={handleErrorClick}
            onDescriptionChange={handleDescriptionChange}
            onCancel={handleCancel}
            onSave={handleSave}
          />
        </div>
      </SelectableCard>
    );
  },
);

ValidableSection.displayName = 'ValidableSection';
